import { FirebaseApp } from 'firebase/app';
import { GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { Auth } from 'firebase/auth';
import { User } from 'firebase/auth';

// const firebaseConfig = {
//   apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
//   authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
//   projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
//   storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
//   appId: import.meta.env.VITE_FIREBASE_APP_ID,
// };

// DISABLED: Wedding app uses custom authentication, not Firebase
// Firebase initialization is disabled to prevent errors
export const firebaseApp: FirebaseApp | null = null;
export const firebaseAuth: Auth | null = null;
export const currentUser: User | null = null;

// Commented out to disable Firebase
// try {
//   firebaseApp = initializeApp(firebaseConfig);
//   firebaseAuth = getAuth(firebaseApp);
//   currentUser = firebaseAuth.currentUser;
// } catch (error) {
//   console.log({ error });
// }

export const googleProvider = new GoogleAuthProvider();
export const microsoftProvider = new OAuthProvider('microsoft.com');

microsoftProvider.setCustomParameters({
  tenant: 'f8cdef31-a31e-4b4a-93e4-5f571e91255a',
});
